export enum TipoUsuario {
  PF = 'PF',
  PJ = 'PJ'
}

export enum TipoUsuarioPorExtenso {
  PF = 'Pessoa Física',
  PJ = 'Pessoa Jurídica'
}
